import { UIState, type UIStateType } from '@/constants/ui/ui-state';

export function useSidebar() {
    const sidebarState = useState<UIStateType>('sidebar', () => UIState.Expanded);

    const isSidebarOpen = computed(() => sidebarState.value === UIState.Expanded);

    const sidebarWidth = computed(() => (isSidebarOpen.value ? 280 : 76));

    function toggleSidebar() {
        sidebarState.value = sidebarState.value === UIState.Expanded ? UIState.Collapsed : UIState.Expanded;
    }

    function closeSidebar() {
        sidebarState.value = UIState.Collapsed;
    }

    function openSidebar() {
        sidebarState.value = UIState.Expanded;
    }

    return {
        isSidebarOpen,
        sidebarWidth,

        toggleSidebar,
        closeSidebar,
        openSidebar
    };
}
